import type { SpaceMember } from "@ably/spaces";
import type { PresenceData } from "@/models";
import type { RealtimeSpace } from "@/ws/realtime-space";

export interface SpacePresenceState {
  instance?: RealtimeSpace;
  members: Record<string, SpaceMember>;
  spaceChannelName?: string; // The actual space channel name (with "space-" prefix), e.g., "space-session-123-main"
  profileData?: PresenceData;
}

export const initSpacePresenceState = (): SpacePresenceState => ({
  instance: undefined,
  members: {},
  spaceChannelName: undefined,
  profileData: undefined,
});

const state: SpacePresenceState = initSpacePresenceState();

export default state;
